

























//@ts-nocheck
//@ts-ignore
import { Component, Vue } from "vue-property-decorator";



//@ts-ignore
import TablePPoa from "@/components/tables/tablev1";
//@ts-ignore
import { email, required } from "vuelidate/lib/validators";
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'
import OrganizationChart from "vue-organization-chart";
import "vue-organization-chart/dist/orgchart.css";
import VueHtml2pdf from "vue-html2pdf";
import bootstrap from "!raw-loader!./bootstrap.css";
import { jsPDF } from "jspdf";
import VueAxios from "vue-axios";
import axios from "axios";
@Component({
  components: {},

  data() {
    return {
      //Linea Accion
   
    };
  },
  mixins: [
   
  ],
  methods: {
    
  },
  created() {},
  mounted() {
   
  },
})
export default class Home extends Vue {}
